export class IdleFactor {
    idleFactorId: number;
    factorSetId: number;
    
    idlePercent: number;
    idleAmountPercent: number;
}